import React from 'react';

const Experience = () => (
  <section className="section experience-section" id="experience" aria-labelledby="experience-title">
    <div className="shell">
      <div className="section-heading section-heading-row"><div><span className="section-number">02 / EXPERIENCE</span><h2 id="experience-title">Building in production.</h2></div><p>Architecture through deployment across 8+ production AI systems, from agent workflows to inference.</p></div>
      <article className="experience-panel">
        <div className="experience-meta"><span className="timeline-marker" /><p className="mono">APR 2025 — PRESENT</p><p>Bengaluru, India</p></div>
        <div className="experience-main"><p className="role-kicker">CURRENT ROLE</p><h3>AI Engineer</h3><p className="experience-company">NxtGen Cloud Technologies Pvt Ltd</p><ul className="editorial-list">
          <li>Architect and deliver multi-agent workflows with LangGraph, routing SQL, retrieval, forecasting, and web research through specialized agents.</li>
          <li>Build document-intelligence and RAG pipelines with asynchronous ingestion, query decomposition, semantic retrieval, and reranking.</li>
          <li>Deploy and tune vLLM and llama.cpp inference across GPU and CPU environments, using quantization and prompt optimization.</li>
          <li>Develop multimodal FastAPI services, authentication, and tool integrations; evaluate agent behavior with traces and guardrails before release.</li>
        </ul><a className="text-link" href="#professional-work">Explore selected company work <span aria-hidden="true">↗</span></a></div>
      </article>
    </div>
  </section>
);

export default Experience;
